import "@hotwired/turbo-rails"
import "./controllers"
import ahoy from "ahoy.js"

// Record which resource and further-reading PDFs a participant downloads.
// TODO trackClicks records a "$click" event with tag/id/class/page/section/text/href,
// but Negotiage::Reports#events_csv and the old export expect a "download" event with
// an "element" property holding the file name. Replace with a click listener on
// a[download] that calls ahoy.track("download", {element: <basename of href>}).
ahoy.trackClicks("a[download]")
